import React from 'react';

export default function CallToAction({ showContactSales }) {
    return (
        <section className="lp-cta">
            <h2>
                Stop guessing.<br />
                Start investing with real data.
            </h2>
            <p>
                Join 500+ firms using MAGNiTT to find opportunities, benchmark markets,
                and win in emerging venture.
            </p>

            <div className="lp-cta__actions">
                <button className="btn btn-main btn-lg lp-cta__btn-sales" onClick={showContactSales}>
                    Contact Sales
                </button>
                <button className="btn lp-cta__btn-demo btn-lg" onClick={showContactSales}>
                    Request a Demo
                </button>
            </div>
        </section>
    );
}
